import {memo, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";
import lscache from "lscache";

import {Text} from "@pg-design/text-module";

import {BOOSTER_STATS} from "../../app/constants/storage_keys";
import {IRPStore} from "../../app/rp_reducer";
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IOfferLeftPropertiesStats} from "../../offer/types/IOfferLeftPropertiesStats";
import {OfferType} from "../../offer/types/OfferType";
import {getPromotionTypeName} from "../../promotion/helpers/PromotionType";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IPropertyDetailOffer} from "../../property/types/IPropertyDetailOffer";
import {getRandomBoosterContent} from "./hooks/use_random_booster_content";
import {getBoosterText} from "./utils/get_booster_text";
import {IPropertyDetailBoosterStats} from "./BoosterDetail.test";
import {BoosterPopover} from "./BoosterPopover";

export interface IChosenStats extends IOfferLeftPropertiesStats {
    type?: string;
}
interface IProps {
    offer: IOfferDetail | IPropertyDetailOffer;
    property?: IPropertyDetail;
    className?: string;
}

interface IBoosterText {
    generatedText: string;
    spanText: string;
}

type BoosterLocalStorage = {
    offer?: Record<number, IBoosterText>;
    property?: Record<number, IBoosterText>;
};

export type BoosterBuildingContentType = "area" | "garage" | "floor" | "north" | "south" | "west" | "east" | "rooms" | "terrace" | "balcony";
const buildingParamVersions: BoosterBuildingContentType[] = ["area", "garage", "floor", "north", "south", "west", "east", "rooms", "terrace", "balcony"];

export const BoosterDetail = memo((props: IProps) => {
    const {offer, property} = props;
    const [boosterText, setBoosterText] = useState<IBoosterText | null>(null);
    const propertyBooster = property as IPropertyDetailBoosterStats;
    lscache.flushExpired();

    const isFlatProperty = property?.offer.type === OfferType.FLAT;
    const isFlatOffer = offer?.type === OfferType.FLAT;
    const propertyPromotion = useSelector((store: IRPStore) => store.property.promotions);
    const offerPromotion = useSelector((store: IRPStore) => store.offerDetail.promotions);
    const userPref = useSelector((store: IRPStore) => store.user.preferences?.data);
    const discount = property ? property.discount : null;
    const promotion = property ? propertyPromotion : offerPromotion;

    if ((promotion && promotion.length > 0) || discount) {
        return (
            <BoosterPopover
                bodyText={<Text variant="headline_6">{!discount ? getPromotionTypeName(promotion[0].type, false) : "Przecena"}</Text>}
                className={props.className}
            />
        );
    }

    // create valid parameter versions
    const updateValidVersions = () => {
        // Make a copy of the original arrays to avoid mutating the default arrays
        let updatedBuildingParamVersions = [...buildingParamVersions];

        // Filter building param versions based on conditions
        if (!property) {
            updatedBuildingParamVersions = updatedBuildingParamVersions.filter(
                (elem) => elem !== "north" && elem !== "south" && elem !== "east" && elem !== "west"
            );
        }

        if ((property && !isFlatProperty) || (offer && !isFlatOffer)) {
            updatedBuildingParamVersions = updatedBuildingParamVersions.filter((elem) => elem !== "floor");
        }

        if ((property && isFlatProperty) || (offer && isFlatOffer)) {
            updatedBuildingParamVersions = updatedBuildingParamVersions.filter((elem) => elem !== "terrace");
        }

        return {
            updatedBuildingParamVersions
        };
    };

    const {updatedBuildingParamVersions} = updateValidVersions();

    // Save boosterStats to localStorage for 240min
    useEffect(() => {
        const localStorageStatsOld: BoosterLocalStorage = lscache.get(BOOSTER_STATS);
        const boosterLS = !property ? localStorageStatsOld?.offer : localStorageStatsOld?.property;
        if (boosterLS && boosterLS[property?.id || offer.id]) {
            setBoosterText(boosterLS[property?.id || offer.id]);
        }
        if (!localStorageStatsOld || (boosterLS && boosterLS[property?.id || offer.id] === undefined)) {
            const randomBoosterContent = getRandomBoosterContent(updatedBuildingParamVersions, offer, userPref, propertyBooster);
            const chosenBoosterText = randomBoosterContent && getBoosterText(randomBoosterContent, offer, propertyBooster);
            setBoosterText(chosenBoosterText ?? null);
            //save boosterStats to localStorage
            chosenBoosterText &&
                lscache.set(
                    BOOSTER_STATS,
                    property ? {property: {...boosterLS, [property.id]: chosenBoosterText}} : {offer: {...boosterLS, [offer.id]: chosenBoosterText}},
                    240
                );
        }
    }, []);

    // add span to text
    const mainText = boosterText?.generatedText;
    const spanText = boosterText?.spanText;
    const bodyText = mainText && spanText && textWithSpan(mainText, spanText);

    return boosterText && <BoosterPopover bodyText={bodyText} className={props.className} />;
});

const textWithSpan = (text: string, wordToWrap: string) => {
    // Split the text into parts: before and after the phrase
    const beforeWord = text.split(wordToWrap)[0];
    const afterWord = text.split(wordToWrap)[1];

    return (
        <Text as="div" variant="headline_6">
            {beforeWord}
            <span css={spanStyle}>{wordToWrap}</span>
            {afterWord}
        </Text>
    );
};

const spanStyle = css`
    background-color: var(--colors-primary);
    font-weight: bold;
`;
import {memo, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";
import lscache from "lscache";

import {Text} from "@pg-design/text-module";

import {BOOSTER_STATS} from "../../app/constants/storage_keys";
import {IRPStore} from "../../app/rp_reducer";
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IOfferLeftPropertiesStats} from "../../offer/types/IOfferLeftPropertiesStats";
import {OfferType} from "../../offer/types/OfferType";
import {getPromotionTypeName} from "../../promotion/helpers/PromotionType";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IPropertyDetailOffer} from "../../property/types/IPropertyDetailOffer";
import {getRandomBoosterContent} from "./hooks/use_random_booster_content";
import {getBoosterText} from "./utils/get_booster_text";
import {IPropertyDetailBoosterStats} from "./BoosterDetail.test";
import {BoosterPopover} from "./BoosterPopover";

export interface IChosenStats extends IOfferLeftPropertiesStats {
    type?: string;
}
interface IProps {
    offer: IOfferDetail | IPropertyDetailOffer;
    property?: IPropertyDetail;
    className?: string;
}

interface IBoosterText {
    generatedText: string;
    spanText: string;
}

type BoosterLocalStorage = {
    offer?: Record<number, IBoosterText>;
    property?: Record<number, IBoosterText>;
};

export type BoosterBuildingContentType = "area" | "garage" | "floor" | "north" | "south" | "west" | "east" | "rooms" | "terrace" | "balcony";
const buildingParamVersions: BoosterBuildingContentType[] = ["area", "garage", "floor", "north", "south", "west", "east", "rooms", "terrace", "balcony"];

export const BoosterDetail = memo((props: IProps) => {
    const {offer, property} = props;
    const [boosterText, setBoosterText] = useState<IBoosterText | null>(null);
    const propertyBooster = property as IPropertyDetailBoosterStats;
    lscache.flushExpired();

    const isFlatProperty = property?.offer.type === OfferType.FLAT;
    const isFlatOffer = offer?.type === OfferType.FLAT;
    const propertyPromotion = useSelector((store: IRPStore) => store.property.promotions);
    const offerPromotion = useSelector((store: IRPStore) => store.offerDetail.promotions);
    const userPref = useSelector((store: IRPStore) => store.user.preferences?.data);
    const discount = property ? property.discount : null;
    const promotion = property ? propertyPromotion : offerPromotion;

    if ((promotion && promotion.length > 0) || discount) {
        return (
            <BoosterPopover
                bodyText={<Text variant="headline_6">{!discount ? getPromotionTypeName(promotion[0].type, false) : "Przecena"}</Text>}
                className={props.className}
            />
        );
    }

    // create valid parameter versions
    const updateValidVersions = () => {
        // Make a copy of the original arrays to avoid mutating the default arrays
        let updatedBuildingParamVersions = [...buildingParamVersions];

        // Filter building param versions based on conditions
        if (!property) {
            updatedBuildingParamVersions = updatedBuildingParamVersions.filter(
                (elem) => elem !== "north" && elem !== "south" && elem !== "east" && elem !== "west"
            );
        }

        if ((property && !isFlatProperty) || (offer && !isFlatOffer)) {
            updatedBuildingParamVersions = updatedBuildingParamVersions.filter((elem) => elem !== "floor");
        }

        if ((property && isFlatProperty) || (offer && isFlatOffer)) {
            updatedBuildingParamVersions = updatedBuildingParamVersions.filter((elem) => elem !== "terrace");
        }

        return {
            updatedBuildingParamVersions
        };
    };

    const {updatedBuildingParamVersions} = updateValidVersions();

    // Save boosterStats to localStorage for 240min
    useEffect(() => {
        const localStorageStatsOld: BoosterLocalStorage = lscache.get(BOOSTER_STATS);
        const boosterLS = !property ? localStorageStatsOld?.offer : localStorageStatsOld?.property;
        if (boosterLS && boosterLS[property?.id || offer.id]) {
            setBoosterText(boosterLS[property?.id || offer.id]);
        }
        if (!localStorageStatsOld || (boosterLS && boosterLS[property?.id || offer.id] === undefined)) {
            const randomBoosterContent = getRandomBoosterContent(updatedBuildingParamVersions, offer, userPref, propertyBooster);
            const chosenBoosterText = randomBoosterContent && getBoosterText(randomBoosterContent, offer, propertyBooster);
            setBoosterText(chosenBoosterText ?? null);
            //save boosterStats to localStorage
            chosenBoosterText &&
                lscache.set(
                    BOOSTER_STATS,
                    property ? {property: {...boosterLS, [property.id]: chosenBoosterText}} : {offer: {...boosterLS, [offer.id]: chosenBoosterText}},
                    240
                );
        }
    }, []);

    // add span to text
    const mainText = boosterText?.generatedText;
    const spanText = boosterText?.spanText;
    const bodyText = mainText && spanText && textWithSpan(mainText, spanText);

    return boosterText && <BoosterPopover bodyText={bodyText} className={props.className} />;
});

const textWithSpan = (text: string, wordToWrap: string) => {
    // Split the text into parts: before and after the phrase
    const beforeWord = text.split(wordToWrap)[0];
    const afterWord = text.split(wordToWrap)[1];

    return (
        <Text as="div" variant="headline_6">
            {beforeWord}
            <span css={spanStyle}>{wordToWrap}</span>
            {afterWord}
        </Text>
    );
};

const spanStyle = css`
    background-color: var(--colors-primary);
    font-weight: bold;
`;
